module.exports = __webpack_public_path__ + "img/HA1512-01.8a6c2b49.jpg";